var PermissionToDocumentMap = /* @__PURE__ */ ((PermissionToDocumentMap2) => {
  PermissionToDocumentMap2["NEWSLETTER"] = "mrkt-email";
  PermissionToDocumentMap2["MARKETING_SMS"] = "mrkt-sms";
  PermissionToDocumentMap2["PAID_MEDIA"] = "mrkt-paidmedia";
  PermissionToDocumentMap2["DATA_PROCESSING"] = "dataprocessing";
  return PermissionToDocumentMap2;
})(PermissionToDocumentMap || {});
var DOC_TYPES = /* @__PURE__ */ ((DOC_TYPES2) => {
  DOC_TYPES2["PAID_MEDIA"] = "doc-mrkt-paidmedia";
  DOC_TYPES2["EMAIL"] = "doc-mrkt-email";
  DOC_TYPES2["SMS"] = "doc-mrkt-sms";
  DOC_TYPES2["DATA_PROCESSING"] = "doc-dataprocessing-promotional-purposes";
  return DOC_TYPES2;
})(DOC_TYPES || {});
var SCENARIO_TYPES = /* @__PURE__ */ ((SCENARIO_TYPES2) => {
  SCENARIO_TYPES2["ACCOUNT_OPTIN"] = "account-optin";
  return SCENARIO_TYPES2;
})(SCENARIO_TYPES || {});
export {
  DOC_TYPES,
  PermissionToDocumentMap,
  SCENARIO_TYPES
};
//# sourceMappingURL=index.js.map
